module.exports = __webpack_public_path__ + "img/adv-mapIcon214.582c3589.png";